import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';

export default function ArticleFeedback() {
  const t = useTranslations('support');
  const [feedback, setFeedback] = useState<'yes' | 'no' | null>(null);

  const handleFeedback = useCallback((value: 'yes' | 'no') => {
    setFeedback((prev) => (prev === value ? null : value));
  }, []);

  const btnBase =
    'min-w-[60px] rounded-md px-3 py-[5px] text-center text-sm font-medium leading-[18px] transition-colors bg-base-fill-secondary hover:bg-base-hover-fill-secondary';

  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-2">
        <i className="iconfont icon-a-thumbup-fill text-xl text-base-label-40" />
        <span className="text-sm leading-5 text-base-label">{t('wasHelpful')}</span>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => handleFeedback('yes')}
          className={`${btnBase} ${feedback === 'yes' ? 'text-base-primary' : 'text-base-label'}`}
        >
          {t('feedbackYes')}
        </button>
        <button
          type="button"
          onClick={() => handleFeedback('no')}
          className={`${btnBase} ${feedback === 'no' ? 'text-base-primary' : 'text-base-label'}`}
        >
          {t('feedbackNo')}
        </button>
      </div>
    </div>
  );
}
